import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import s1 from "../assets/s1.png";
import s2 from "../assets/s2.png";
import s3 from "../assets/s3.png";
import s4 from "../assets/s4.png";
import s5 from "../assets/s5.png";
import s6 from "../assets/s6.png";
import s7 from "../assets/s7.png";
import s8 from "../assets/s8.png";
import s9 from "../assets/s9.png";
import s10 from "../assets/s10.png";
import s11 from "../assets/s11.png";
import s12 from "../assets/s12.png";
import s13 from "../assets/s13.png";
import s14 from "../assets/s14.png";
import s15 from "../assets/s15.png";
import s16 from "../assets/s16.png";
import s17 from "../assets/s17.png";
import s18 from "../assets/s18.png";

const Speakers = () => {
  const speakers = [
    { name: 'Dipankar Nandi',college:'IISc, Bangalore', description: 'Microbial and host encoded responses to stress and infection', image: s1 },
    { name: 'Pranjal Chandra',college:'IIT (BHU), Varanasi', description: 'Immunodiagnostics, Point-of-care Techniques, Nanobiotechnology', image: s2 },
    { name: 'Rahul Purwar',college:'IIT Bombay', description: 'Immune engineering, Tumor Immunology, Cancer biomarker', image: s3 },
    { name: 'Amit Awasthi',college:'THSTI, New Delhi', description: 'T cell differentiation pathways, Metabolic regulation of T cells, Transcriptional regulations', image: s4 },
    { name: 'Javed Agrewala',college:'I.I.T. Ropar', description: 'Immunology of Infectious Diseases, Vaccines, and Gut Microbiome', image: s5 },
    { name: 'Arun Trivedi',college:' CDRI Lucknow', description: 'Cancer Biology, Protein-Protein interaction', image: s6 },
    { name: 'Mrigank Srivastava',college:' CDRI Lucknow', description: 'Cellular and Molecular Immunology', image: s7 },
    { name: 'Mayank Singh',college:' AIIMS New Delhi', description: 'Immunotherapy and its application in Cancer therapeutics', image: s8 },
    { name: 'Kulwant Singh',college:' SGPGIMS Lucknow', description: 'CAR T cell therapy, Cell type specific transcription factors and epigenetic regulators', image: s9 },
    { name: 'Rupesh Srivastava',college:' AIIMS New Delhi', description: 'Immunopatho physiology of Osteoporosis, Osteoimmunology', image: s10 },
    { name: 'Satish Mishra',college:' CDRI Lucknow', description: 'Vaccine Development for Malaria, host-parasite interactions during malaria transmission', image: s11 },
    { name: 'Priyankar Dey',college:' Thapar Institute of Engineering & Technology', description: 'Gut microbiota, Chronic metabolic disease, Immunopharmacology', image: s12 },
    { name: 'Amit Lahiri',college:' CDRI Lucknow', description: 'Inflammatory Bowel disease, mucosal immunology, mitochondrial role in inflammation', image: s13 },
    { name: 'Rajesh Kumar',college:' IIT Roorkee', description: 'Antibody Engineering, Development of Antibody Based Therapeutic Interventions for Emerging and Re-emerging viral diseases', image: s14 },
    { name: 'Geeta Rai',college:' BHU, Varanasi', description: 'Immunogenetics, Biosimilar development', image: s15 },
    { name: 'Budhaditya Mukherjee',college:' IIT Kharagpur', description: 'Genome editing techniques for the characterization of key components of protozoan disease pathogenesis', image: s16 },
    { name: 'Gayatri Mukherjee',college:' IIT Kharagpur', description: 'Immune regulation by exosomes, T cell exhaustion, Development of Immunetherapeutics, soluble immune checkpoint molecules', image: s17 },
    { name: 'Hridayesh Prakash',college:' Amity Centre of Translational Research, New Delhi', description: 'Translational Immunology, Cancer Immunology, Radiotherapy Immunotherapy of Tuberculosis', image: s18 },
  ];

  const CustomPrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white border border-gray-300 shadow-lg p-3 rounded-full hover:bg-gray-100 transition-all z-10"
      aria-label="Previous"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
  );

  const CustomNextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white border border-gray-300 shadow-lg p-3 rounded-full hover:bg-gray-100 transition-all z-10"
      aria-label="Next"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className="bg-white py-12 overflow-hidden">
      <h1 className="text-3xl lg:text-4xl font-bold text-center mb-2">
        <span className="bg-gradient-to-r from-indigo-600 to-blue-400 text-transparent bg-clip-text">Our Speakers</span>
      </h1>
      <div className="max-w-6xl mx-auto px-4 overflow-hidden relative">
        <Slider {...settings}>
          {speakers.map((speaker, index) => (
            <div key={index} className="p-4">
              <div className="bg-white rounded-lg overflow-hidden transform sm:hover:scale-105 transition-transform duration-300">
                <div className="mx-auto w-48 h-48 overflow-hidden rounded-full">
                  <img src={speaker.image} alt={speaker.name} className="w-full h-auto object-cover" />
                </div>
                <div className="p-6 text-center">
                  <h2 className="text-xl font-bold text-gray-800 mb-2">{speaker.name}</h2>
                  <p className="text-indigo-600">{speaker.college}</p>
                  <p className="text-gray-600">{speaker.description}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Speakers;
